import {connect} from 'react-redux';
import React from 'react';

import UserModel from '/app/src/model/User/model';
import SystemModel from '/app/src/model/System/model';

import ConversationSelector from '/app/src/model/Conversation/selector';
import EmployeeSelector from '/app/src/model/Employee/selector';
import EntrySelector from '/app/src/model/Entry/selector';
import UserSelector from '/app/src/model/User/selector';

import ConversationPreview from './Conversation'

class InternContainer extends React.Component {
    __resolveButtonClick(room){
        return () => {
            this.props.dispatch(UserModel.resolveTicket(room));
        }
    }
    __transferButtonClick(room){
        return () => {
            this.props.dispatch(SystemModel.openModal('transfer', {'room': room}));
        }
    }

    render()
    {
        try {
            let {room, name, isOnline, imageUrl, conversation} = this.props
            let entry = ConversationSelector.lastEntry(conversation)
            let entryBody =  EntrySelector.body(entry)
            const isTyping = this.props.isTyping;

            // HACK: this happends when an employee is removed
            if(!name) return null
            if(!entryBody) entryBody = 'Starta ny konversation'
            let entryDateCreated = EntrySelector.detailsDateCreated(entry)

            let send = EntrySelector.creatorId(entry) === this.props.userId

            let currentRoom = this.props.currentRoom

            return (
                <ConversationPreview
                    room={room}
                    currentRoom={currentRoom}
                    title={this.props.name}
                    isOnline={isOnline}
                    imageUrl={imageUrl}
                    entryBody={entryBody}
                    entryDateCreated={entryDateCreated}
                    unread={this.props.unread}
                    send={send}
                    isTyping={isTyping}
                    />
            );
        }
        catch(err){
            // TODO: some of the setup data is missing, hence we came here
            // need more error checking done here
            //console.log(err);
            return null;
        }


    }
}

function mapStateToProps(state, ownProps){
    const userId = UserSelector.getId(state)
    let conversation = ConversationSelector.getByRoom(state, ownProps.room)
    let participants = ConversationSelector.getParticipantsId(conversation)
    let unread = ConversationSelector.getUnread(conversation, userId)
    const isTyping = ConversationSelector.getIsTyping(state, ownProps.room);

    if(!participants){
        return {}
    }

    let coworkerId = participants.filter(participant => participant !== userId).get(0)
    let coworker = EmployeeSelector.getById(state, coworkerId)

    let name = coworker.get('name')
    let isOnline = coworker.get('is_online')
    let imageUrl = coworker.get('image_url')

    return {
        conversation,
        name,
        unread,
        isOnline,
        imageUrl,
        isTyping
    }
}

export default connect(mapStateToProps)(InternContainer);



// WEBPACK FOOTER //
// ./src/component/Conversation/Preview/InternContainer.js